import { Component, Inject } from '@angular/core';
import { finalize, catchError, interval, of, takeUntil } from 'rxjs';

import { ChangeDetectorRef, NgZone, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CommonService } from '../../../../shared/services/common.service';
import { CaptchaService } from '../../../../shared/services/captcha.service';
import { ApiService } from "../../../../shared/services/api.service";
import { AutofilliaService } from "../../../../shared/services/autofillia.service";
import { API_ENDPOINTS } from '../../../../shared/utils/const';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialog } from '@angular/material/dialog';
import { TemplateRef, ViewChild } from '@angular/core';
//import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import autoTable from 'jspdf-autotable';

import 'jspdf-autotable';


//import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { jsPDF } from 'jspdf'; // Keep this import
import { PreviewfileComponent } from '../../previewfile/previewfile.component';


//import { CommonService } from '../../../../../shared/services/common.service';


@Component({
  selector: 'app-eoi',
  templateUrl: './eoi.component.html',
  styleUrl: './eoi.component.css'
})
export class EoiComponent implements OnInit {

  @ViewChild('warningDialog') warningDialog!: TemplateRef<any>;

  constructor(private router: Router, private ia_serv: AutofilliaService, private fb: FormBuilder, private apiService: ApiService, private toastr: ToastrService, private captchaService: CaptchaService, private ngZone: NgZone,
    private common: CommonService, private commonService: CommonService, private ngxUiLoaderService: NgxUiLoaderService, private toastrService: ToastrService,
    private cdr: ChangeDetectorRef, public dialog: MatDialog) {

  }
  form = new FormGroup({
    UdyamRegistrationNumber: new FormControl({ value: '', readonly: true }, [Validators.required, Validators.pattern(this.commonService.udyamNumber)]),
    EnterpriseName: new FormControl({ value: '', readonly: true }, [Validators.required, Validators.minLength(3), Validators.pattern(this.common.enterpriseNamePattern)]),
    AuthorizedPersonName: new FormControl({ value: '', readonly: true }, [Validators.required]),
    Gender: new FormControl('', [Validators.required]),
    SocialCategory: new FormControl('', [Validators.required]),
    EnterpriseType: new FormControl('', [Validators.required]),

    EmailID: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]),
    MobileNumber: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(this.common.mobilePattern)]),
    DateOfEstablishment: new FormControl('', [Validators.required]),
    PresentAddress: new FormControl('', [Validators.required]),
    District: new FormControl('', [Validators.required]),
    DistrictId: new FormControl('', [Validators.required]),
    Pin: new FormControl('', [Validators.required, Validators.pattern('[0-9]{6}')]),
    RentAgreementName: new FormControl('', [Validators.required]),
    RentAgreementFile: new FormControl(null),
    RentAgreementPath: new FormControl(null),
    /*CurrentSpaceLocation: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),*/
    AreaOfCurrentSpace: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),


    CurrentRentPaid: new FormControl('', [Validators.required, Validators.pattern('^\\d+(\\.\\d{1,2})?$')]),
    RentFrequency: new FormControl('', [Validators.required]),
    UploadLastTwoRentPaymentReceiptsName: new FormControl('', [Validators.required]),
    UploadLastTwoRentPaymentReceiptsFile: new FormControl(null),
    UploadLastTwoRentPaymentReceiptsPath: new FormControl(null),
    NumberOfEmployees: new FormControl('', [Validators.required, Validators.min(5)]),
    SelfCertificationName: new FormControl('', [Validators.required]),
    SelfCertificationFile: new FormControl(null),
    SelfCertificationPath: new FormControl(null),
    Sector: new FormControl({ value: '', readonly: true }, [Validators.required]),
    PresentProductName: new FormControl('', [Validators.required]),
    PresentProductFile: new FormControl(null),
    PresentProductPath: new FormControl(null),
    NICCode: new FormControl({ value: '', readonly: true }, [Validators.required]),
    UdyamCertificateName: new FormControl('', [Validators.required]),
    UdyamCertificateFile: new FormControl(null),
    UdyamCertificatePath: new FormControl(null),
    PanCardNumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]),
    PanCardNumberName: new FormControl('', [Validators.required]),
    PanCardNumberFile: new FormControl(null),
    PanCardNumberPath: new FormControl(null),
    //GSTRegistrationNumber: new FormControl('', [Validators.required, Validators.minLength(15), Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z][0-9A-Z]{1}$')]),
    GSTRegistrationNumber: new FormControl('', [Validators.minLength(15), Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z][0-9A-Z]{1}$')]),
    GSTRegistrationCertificateName: new FormControl('', [Validators.required]),
    GSTRegistrationCertificateFile: new FormControl(null),
    GSTRegistrationCertificatePath: new FormControl(null),
    CPCBName: new FormControl('', [Validators.required]),
    CPCBFile: new FormControl(null),
    CPCBPath: new FormControl(null),
    //termsConditionAccepted: new FormControl('', [Validators.required]),
    isTermsConditionAccepted: new FormControl(false, [Validators.requiredTrue]),
    isAddlTermsConditionAccepted: new FormControl(false, [Validators.requiredTrue]),
    // *** START OF NEW FORM FIELDS FOR THE TABLE ***
    //financialData: new FormGroup({
    //  '2020_21': new FormGroup({
    //    Turnover: new FormControl('', [Validators.required, Validators.pattern('^[0-9]')]),
    //    UploadFile: new FormControl(null),
    //    UploadName: new FormControl(''), // To store file name
    //    UploadPath: new FormControl(null), // To store file path on server
    //  }),
    //  '2021_22': new FormGroup({
    //    Turnover: new FormControl('', [Validators.required, Validators.pattern('^[0-9]')]),
    //    UploadFile: new FormControl(null),
    //    UploadName: new FormControl(''), // To store file name
    //    UploadPath: new FormControl(null),
    //  }),
    //  '2022_23': new FormGroup({
    //    Turnover: new FormControl('', [Validators.required, Validators.pattern('^[0-9]')]),
    //    UploadFile: new FormControl(null),
    //    UploadName: new FormControl(''), // To store file name
    //    UploadPath: new FormControl(null),
    //  }),
    //  '2023_24': new FormGroup({
    //    Turnover: new FormControl('', [Validators.required, Validators.pattern('^[0-9]')]),
    //    UploadFile: new FormControl(null),
    //    UploadName: new FormControl(''), // To store file name
    //    UploadPath: new FormControl(null),
    //  }),
    //  '2024_25': new FormGroup({
    //    Turnover: new FormControl('', [Validators.required, Validators.pattern('^[0-9]')]),
    //    UploadFile: new FormControl(null),
    //    UploadName: new FormControl(''), // To store file name
    //    UploadPath: new FormControl(null),
    //  }),
    //})

    //finalcialTurnover: this.fb.array([])
    TurnoverFY2020_21: new FormControl('', [Validators.required,Validators.pattern('^[0-9]+(\.[0-9]{1,2})?')]),
    FY2020_21_File: new FormControl(null),
    FY2020_21_Name: new FormControl('', [Validators.required]), // To store file name
    FY2020_21_Path: new FormControl(null),

    TurnoverFY2021_22: new FormControl('', [Validators.required,Validators.pattern('^[0-9]+(\.[0-9]{1,2})?')]),
    FY2021_22_File: new FormControl(null),
    FY2021_22_Name: new FormControl('', [Validators.required]), // To store file name
    FY2021_22_Path: new FormControl(null),

    TurnoverFY2022_23: new FormControl('', [Validators.required,Validators.pattern('^[0-9]+(\.[0-9]{1,2})?')]),
    FY2022_23_File: new FormControl(null),
    FY2022_23_Name: new FormControl('', [Validators.required]), // To store file name
    FY2022_23_Path: new FormControl(null),

    TurnoverFY2023_24: new FormControl('', [Validators.required,Validators.pattern('^[0-9]+(\.[0-9]{1,2})?')]),
    FY2023_24_File: new FormControl(null),
    FY2023_24_Name: new FormControl('', [Validators.required]), // To store file name
    FY2023_24_Path: new FormControl(null),

    TurnoverFY2024_25: new FormControl('', [Validators.required,Validators.pattern('^[0-9]+(\.[0-9]{1,2})?')]),
    FY2024_25_File: new FormControl(null),
    FY2024_25_Name: new FormControl('', [Validators.required]), // To store file name
    FY2024_25_Path: new FormControl(null),

  }

  );

  //modalRef: BsModalRef;
  RentAgreementFile: File | null = null;
  RentAgreementErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  maxSizeInMB = 5; // Set file size limit (2 MB in this case)
  RentAgreementUrl: string | null = null; // Store image URL
  file: File | null = null;
  UploadLastTwoRentPaymentReceiptsFile: File | null = null;
  UploadLastTwoRentPaymentReceiptsErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  UploadLastTwoRentPaymentReceiptsUrl: string | null = null; // Store image URLUrl: string | null = null; // Store image URL
  SelfCertificationFile: File | null = null;
  SelfCertificationErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  SelfCertificationUrl: string | null = null; // Store image URL
  PresentProductFile: File | null = null;
  PresentProductErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  PresentProductUrl: string | null = null; // Store image URL
  UdyamCertificateFile: File | null = null;
  UdyamCertificateErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  UdyamCertificateUrl: string | null = null; // Store image URL
  PanCardNumberFile: File | null = null;
  PanCardNumberErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  PanCardNumberUrl: string | null = null; // Store image URL
  GSTRegistrationCertificateFile: File | null = null;
  GSTRegistrationCertificateErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  GSTRegistrationCertificateUrl: string | null = null; // Store image URL
  CPCBFile: File | null = null;
  CPCBErrors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  CPCBUrl: string | null = null; // Store image URL
  uploadError: string | null = null;
  public isSubmitted: boolean = false;
  isTermsConditionAccepted: boolean = false;
  isAddlTermsConditionAccepted: boolean = false;
  FY2020_21_File: File | null = null;
  FY2020_21_Errors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  FY2020_21_Url: string | null = null; // Store image URL
  FY2021_22_File: File | null = null;
  FY2021_22_Errors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  FY2021_22_Url: string | null = null; // Store image URL
  FY2022_23_File: File | null = null;
  FY2022_23_Errors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  FY2022_23_Url: string | null = null; // Store image URL
  FY2023_24_File: File | null = null;
  FY2023_24_Errors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  FY2023_24_Url: string | null = null; // Store image URL
  FY2024_25_File: File | null = null;
  FY2024_25_Errors: { typeError: boolean; sizeError: boolean; } = { typeError: false, sizeError: false };
  FY2024_25_Url: string | null = null; // Store image URL
  isVerified = false;
  loadingSequence: boolean = false;
  district: any = [];
  dropdownList: any = [];
  district_help: any[] = [];
  districtsBasedOnState: any[] = [];
  //const html2canvas: any;
  //const jspdf: any;



  async ngOnInit(): Promise<void> {

    const incomingFormData = history.state.eoiData;
    if (incomingFormData) {

      // Assuming incomingFormData.DateOfEstablishment is '20/12/2015'
      const originalDateString = incomingFormData.DateOfEstablishment;
      let formattedDate: string | null = null;

      if (originalDateString) {
        // Split the date string by '/'
        const parts = originalDateString.split('/');

        // Ensure there are three parts (day, month, year)
        if (parts.length === 3) {
          const day = parts[0];
          const month = parts[1];
          const year = parts[2];

          // Format the date to 'YYYY-MM-DD'
          formattedDate = `${year}-${month}-${day}`;
        }
      }

      
      this.form.patchValue({
        UdyamRegistrationNumber: incomingFormData.UdyamRegistrationNumber,
        EnterpriseName: incomingFormData.EnterpriseName,
        AuthorizedPersonName: incomingFormData.AuthorizedPersonName,
        DateOfEstablishment: formattedDate,
        Sector: incomingFormData.Sector,
        /*PresentAddress: incomingFormData.PresentAddress,*/
        NICCode: incomingFormData.NICCode,
        /*Pin: incomingFormData.Pin,*/
        Gender: incomingFormData.Gender,
        SocialCategory: incomingFormData.SocialCategory,
        EnterpriseType: incomingFormData.EnterpriseType,
        District: incomingFormData.District,
        
      });

      //this.form.get('UdyamRegistrationNumber')?.disable();
      //this.form.get('EnterpriseName')?.disable();
      //this.form.get('AuthorizedPersonName')?.disable();
      
      //this.form.get('PresentAddress')?.disable();
      //this.form.get('NICCode')?.disable();
      if (formattedDate) {
        this.isVerified = true;
      }

    }

    this.loadDistricts();
  }
  
  get f() {
    return this.form.controls;
  }

  numberOnly(event: KeyboardEvent): void {
    const charCode = event.keyCode || event.which;
    if (charCode < 48 || charCode > 57) {
      // Allow only numbers
      event.preventDefault();
    }
  }

  pinnumberOnly(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Allow backspace, delete, and arrow keys to function normally.
    //if (charCode === 8 || charCode === 46 || (charCode >= 37 && charCode <= 40)) {
    //  return;
    //}

    // Allow only number keys (0-9) from both the main keyboard and the numpad.
    if (charCode >= 48 && charCode <= 57) {
      // Check if the input is too long.
      if (currentValue.length >= 6) {
        event.preventDefault();
        return;
      }

      // Prevent a '0' as the first character.
      if (currentValue.length === 0 && charCode === 48) {
        event.preventDefault();
        return;
      }
    } else {
      // For any character that is not a number or an allowed control key,
      // prevent the default action (i.e., typing the character).
      event.preventDefault();
    }
  }

  oldnumberandDotOnly(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    const target = event.target as HTMLInputElement;

    // Allow only numbers (0-9)
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      // Allow the decimal point (charCode 46) only if it hasn't been entered yet
      if (charCode === 46) {
        if (target.value.indexOf('.') === -1) {
          return; // Allow the first dot
        }
      }
      event.preventDefault(); // Block other characters
    }
  }

  nnumberandDotOnly(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    const target = event.target as HTMLInputElement;
    const value = target.value;

    // Allow backspace (8), delete (46), Tab (9), and arrow keys (37, 39) for usability.
    if (charCode === 8 || charCode === 9 || charCode === 37 || charCode === 39) {
      return;
    }

    // Allow only numbers (0-9), preventing all other non-numeric characters.
    if (charCode < 48 || charCode > 57) {
      // If the character is not a number, check if it's the decimal point (46).
      if (charCode === 46) {
        // If a dot already exists in the input value, prevent a second one.
        if (value.indexOf('.') !== -1) {
          event.preventDefault();
          return;
        }
      } else {
        // Block all other characters that are not numbers or a dot.
        event.preventDefault();
        return;
      }
    }

    // Check the number of decimal places.
    const decimalIndex = value.indexOf('.');
    // If a decimal point exists and the user is typing to the right of it,
    // check the length of the fractional part.
    if (decimalIndex !== -1) {
      const decimalPart = value.substring(decimalIndex + 1);

      // Add a null-check here to ensure 'target.selectionStart' is not null.
      if (target.selectionStart !== null) {
        const caretPosition = target.selectionStart;

        // The caret must be to the right of the decimal point to be affected by this rule.
        if (caretPosition > decimalIndex) {
          // If there are already two or more digits after the dot, block further input.
          if (decimalPart.length >= 2) {
            event.preventDefault();
          }
        }
      }
    }
  }

  numberandDotOnly(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const key = event.key;

    // Allow navigation and editing keys
    if (
      key === 'Backspace' ||
      key === 'Tab' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key === 'Delete'
    ) {
      return;
    }

    // Allow only numbers
    if (/\d/.test(key)) {
      // Check for decimal places
      const decimalIndex = value.indexOf('.');
      if (decimalIndex !== -1) {
        const decimalPart = value.substring(decimalIndex + 1);
        const caretPosition = target.selectionStart;

        if (caretPosition !== null && caretPosition > decimalIndex) {
          if (decimalPart.length >= 2) {
            event.preventDefault();
          }
        }
      }
      return;
    }

    // Allow only one decimal point
    if (key === '.') {
      if (value.indexOf('.') !== -1) {
        event.preventDefault();
      }
      return;
    }

    // Block all other characters
    event.preventDefault();
  }

  numberanddashOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
      return false;
    }
    return true;
  }
  textOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
      return false;
    }
    return true;
  }

  textAndSpaceOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const target = event.target as HTMLInputElement;
    const currentValue = target.value;

    // Allow letters (A-Z, a-z) and a single space (not after another space)
    if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      (charCode === 32 && !currentValue.endsWith(' '))) { // Space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }
  textAndSpaceAndDotOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);
    const target = event.target as HTMLInputElement; // Get the input element
    const currentValue = target.value;

    // Allow letters (A-Z, a-z), single space, and dot (.)
    if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 46 || // Dot
      (charCode === 32 && !currentValue.endsWith(' '))) { // Single space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }

  textandspecialcharsOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 32 || charCode > 47)) {
      return false;
    }
    return true;
  }
  preventStartingSpace(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    // Prevent starting space
    // Prevent leading space
    if (inputElement.selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
    }

    // Remove trailing spaces immediately on "Enter" or "Tab"
    if (event.key === 'Enter' || event.key === 'Tab') {
      inputElement.value = inputElement.value.trim();
    }
  }

  // Additional function to handle trailing spaces on blur
  removeTrailingSpacesOnBlur(inputElement: HTMLInputElement): void {
    inputElement.value = inputElement.value.trim();
  }
  numberAndCapitalAlphabetsOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow numbers (0-9), uppercase letters (A-Z), and lowercase letters (a-z)
    if (
      (charCode >= 48 && charCode <= 57) || // Numbers
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) // Lowercase letters
    ) {
      // If the input is a lowercase letter, convert it to uppercase
      if (charCode >= 97 && charCode <= 122) {
        event.target.value += String.fromCharCode(charCode).toUpperCase();
        event.preventDefault(); // Prevent adding the original lowercase letter
      }
      return true;
    }

    // Block all other characters

    return false;

  }

  onReset() {
    if (confirm("Are you sure you want to reset the form?")) {

      // Clear history state formData
      history.replaceState({}, '', window.location.pathname);

      //this.form.reset();


      sessionStorage.clear();
      this.form.reset();//added to reset the form



    }
  }
  //onInputPan(event: any): void {
  //  let input = event.target.value.toUpperCase();
  //  let formattedInput = '';

  //  for (let i = 0; i < input.length; i++) {
  //    if (i < 5 && /[A-Z]/.test(input[i])) {
  //      formattedInput += input[i];
  //    } else if (i >= 5 && i < 9 && /\d/.test(input[i])) {
  //      formattedInput += input[i];
  //    } else if (i === 9 && /[A-Z]/.test(input[i])) {
  //      formattedInput += input[i];
  //    } else {
  //      break;
  //    }
  //  }
  //  event.target.value = formattedInput;
  //  this.form.get('organisationPAN')?.setValue(formattedInput, { emitEvent: false });

  //  this.panInGstValidator();


  //}
  //panInGstValidator() {

  //  const organisationPAN = this.form.get('organisationPAN')?.value;
  //  const gstNumber = this.form.get('gstNumber')?.value;

  //  if (organisationPAN && gstNumber) {
  //    // If the PAN is not part of the GST Number, show the error
  //    if (!gstNumber.includes(organisationPAN)) {
  //      this.panNotInGst = true;
  //    } else {
  //      // If PAN is present in GST, reset the error flag
  //      this.panNotInGst = false;
  //    }
  //  } else {
  //    // Reset the error flag if fields are empty
  //    this.panNotInGst = false;
  //  }
  //}

  

  onRentAgreementFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.RentAgreementErrors = { typeError: false, sizeError: false };
    this.form.get('RentAgreementName')?.setValue('');

    if (input.files && input.files.length) {
      this.RentAgreementFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.RentAgreementFile.type !== 'application/pdf') {
        this.RentAgreementErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.RentAgreementFile.size > maxSizeInBytes) {
        this.RentAgreementErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.RentAgreementErrors.typeError || this.RentAgreementErrors.sizeError) {
        this.form.get('RentAgreementFile')?.setValue(null); // Clear the file control
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          RentAgreementName: this.RentAgreementFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), also clear the form control and name
      this.form.get('RentAgreementName')?.setValue('');
      this.form.get('RentAgreementFile')?.setValue(null);
    }
  }

  

  onUploadLastTwoRentPaymentReceiptsFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.UploadLastTwoRentPaymentReceiptsErrors = { typeError: false, sizeError: false };
    this.form.get('UploadLastTwoRentPaymentReceiptsName')?.setValue('');

    if (input.files && input.files.length) {
      this.UploadLastTwoRentPaymentReceiptsFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.UploadLastTwoRentPaymentReceiptsFile.type !== 'application/pdf') {
        this.UploadLastTwoRentPaymentReceiptsErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.UploadLastTwoRentPaymentReceiptsFile.size > maxSizeInBytes) {
        this.UploadLastTwoRentPaymentReceiptsErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.UploadLastTwoRentPaymentReceiptsErrors.typeError || this.UploadLastTwoRentPaymentReceiptsErrors.sizeError) {
        this.form.get('UploadLastTwoRentPaymentReceiptsFile')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          UploadLastTwoRentPaymentReceiptsName: this.UploadLastTwoRentPaymentReceiptsFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('UploadLastTwoRentPaymentReceiptsName')?.setValue('');
      this.form.get('UploadLastTwoRentPaymentReceiptsFile')?.setValue(null);
    }
  }
  

  onSelfCertificationFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.SelfCertificationErrors = { typeError: false, sizeError: false };
    this.form.get('SelfCertificationName')?.setValue('');

    if (input.files && input.files.length) {
      this.SelfCertificationFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.SelfCertificationFile.type !== 'application/pdf') {
        this.SelfCertificationErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.SelfCertificationFile.size > maxSizeInBytes) {
        this.SelfCertificationErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.SelfCertificationErrors.typeError || this.SelfCertificationErrors.sizeError) {
        this.form.get('SelfCertificationFile')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          SelfCertificationName: this.SelfCertificationFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('SelfCertificationName')?.setValue('');
      this.form.get('SelfCertificationFile')?.setValue(null);
    }
  }
  

  onPresentProductFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.PresentProductErrors = { typeError: false, sizeError: false };
    this.form.get('PresentProductName')?.setValue('');

    if (input.files && input.files.length) {
      this.PresentProductFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.PresentProductFile.type !== 'application/pdf') {
        this.PresentProductErrors.typeError = true; // Corrected: Using PresentProductErrors
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.PresentProductFile.size > maxSizeInBytes) {
        this.PresentProductErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.PresentProductErrors.typeError || this.PresentProductErrors.sizeError) {
        this.form.get('PresentProductFile')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          PresentProductName: this.PresentProductFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('PresentProductName')?.setValue('');
      this.form.get('PresentProductFile')?.setValue(null);
    }
  }
  

  onUdyamCertificateFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.UdyamCertificateErrors = { typeError: false, sizeError: false };
    this.form.get('UdyamCertificateName')?.setValue('');

    if (input.files && input.files.length) {
      this.UdyamCertificateFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.UdyamCertificateFile.type !== 'application/pdf') {
        this.UdyamCertificateErrors.typeError = true; // Corrected: Using UdyamCertificateErrors
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.UdyamCertificateFile.size > maxSizeInBytes) {
        this.UdyamCertificateErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.UdyamCertificateErrors.typeError || this.UdyamCertificateErrors.sizeError) {
        this.form.get('UdyamCertificateFile')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          UdyamCertificateName: this.UdyamCertificateFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('UdyamCertificateName')?.setValue('');
      this.form.get('UdyamCertificateFile')?.setValue(null);
    }
  }
  

  onPanFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.PanCardNumberErrors = { typeError: false, sizeError: false };
    this.form.get('PanCardNumberName')?.setValue('');

    if (input.files && input.files.length) {
      this.PanCardNumberFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.PanCardNumberFile.type !== 'application/pdf') {
        this.PanCardNumberErrors.typeError = true; // Corrected: Using PanCardNumberErrors
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.PanCardNumberFile.size > maxSizeInBytes) {
        this.PanCardNumberErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.PanCardNumberErrors.typeError || this.PanCardNumberErrors.sizeError) {
        this.form.get('PanCardNumberFile')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          PanCardNumberName: this.PanCardNumberFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('PanCardNumberName')?.setValue('');
      this.form.get('PanCardNumberFile')?.setValue(null);
    }
  }
  

  onGstFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.GSTRegistrationCertificateErrors = { typeError: false, sizeError: false };
    this.form.get('GSTRegistrationCertificateName')?.setValue('');

    if (input.files && input.files.length) {
      this.GSTRegistrationCertificateFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.GSTRegistrationCertificateFile.type !== 'application/pdf') {
        this.GSTRegistrationCertificateErrors.typeError = true; // Corrected: Using GSTRegistrationCertificateErrors
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.GSTRegistrationCertificateFile.size > maxSizeInBytes) {
        this.GSTRegistrationCertificateErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.GSTRegistrationCertificateErrors.typeError || this.GSTRegistrationCertificateErrors.sizeError) {
        this.form.get('GSTRegistrationCertificateFile')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          GSTRegistrationCertificateName: this.GSTRegistrationCertificateFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('GSTRegistrationCertificateName')?.setValue('');
      this.form.get('GSTRegistrationCertificateFile')?.setValue(null);
    }
  }
  

  onCPCBFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.CPCBErrors = { typeError: false, sizeError: false };
    this.form.get('CPCBName')?.setValue('');

    if (input.files && input.files.length) {
      this.CPCBFile = input.files[0];

      // Validate file type (Only PDF)
      if (this.CPCBFile.type !== 'application/pdf') {
        this.CPCBErrors.typeError = true; // Corrected: Using CPCBErrors
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.CPCBFile.size > maxSizeInBytes) {
        this.CPCBErrors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.CPCBErrors.typeError || this.CPCBErrors.sizeError) {
        this.form.get('CPCBFile')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          CPCBName: this.CPCBFile.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('CPCBName')?.setValue('');
      this.form.get('CPCBFile')?.setValue(null);
    }
  }
  prepareFormData(): FormData {

    //console.log(this.form.value)
    const formData = new FormData();

    
    

    // Retrieve IndustryAssociationId from session storage
    //const IndustryAssociationId = sessionStorage.getItem('iauserid');

    //const IAUserId = sessionStorage.getItem('industryAssociationUserId');
    //const EventId = sessionStorage.getItem('EventId');

    // Append IndustryAssociationId to FormData
    //if (EventId) {
    //  formData.append('EventId', EventId); // Append the ID
    //}

    //// Append form values to FormData
    //Object.keys(this.form.value).forEach(key => {
    //  const value = this.form.get(key)?.value;
    //  if (value !== null) {
    //    formData.append(key, value);
    //    //console.log(key, value);
    //  }
    //});

    // Append form values to FormData, excluding 'mobotp'
    //Object.keys(this.form.value).forEach(key => {
    //  if (key !== 'mobotp') { // Exclude 'mobotp' field
    //    const value = this.form.get(key)?.value;
    //    if (value !== null) {
    //      formData.append(key, value);
    //    }
    //  }
    //});


    // Append main form values to FormData, excluding 'mobotp' and the 'newParticipants' FormArray
    Object.keys(this.form.value).forEach(key => {
      // Exclude 'mobotp' (handled separately or not needed) and 'newParticipants' (iterated below)
      
        const value = this.form.get(key)?.value;
        // Append only if the value is not null or undefined
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      
    });


    // Append the file separately if it exists
    if (this.RentAgreementFile) {
      formData.append('RentAgreementFile', this.RentAgreementFile);

    }
    if (this.UploadLastTwoRentPaymentReceiptsFile) {

      formData.append('UploadLastTwoRentPaymentReceiptsFile', this.UploadLastTwoRentPaymentReceiptsFile);
    }

    if (this.SelfCertificationFile) {

      formData.append('SelfCertificationFile', this.SelfCertificationFile);
    }
    if (this.PresentProductFile) {

      formData.append('PresentProductFile', this.PresentProductFile);
    }
    if (this.UdyamCertificateFile) {

      formData.append('UdyamCertificateFile', this.UdyamCertificateFile);
    }
    if (this.PanCardNumberFile) {

      formData.append('PanCardNumberFile', this.PanCardNumberFile);
    }
    if (this.GSTRegistrationCertificateFile) {

      formData.append('GSTRegistrationCertificateFile', this.GSTRegistrationCertificateFile);
    }
    if (this.CPCBFile) {

      formData.append('CPCBFile', this.CPCBFile);
    }
    if (this.FY2020_21_File) {

      formData.append('FY2020_21_File', this.FY2020_21_File);
    }
    if (this.FY2021_22_File) {

      formData.append('FY2021_22_File', this.FY2021_22_File);
    }
    if (this.FY2022_23_File) {

      formData.append('FY2022_23_File', this.FY2022_23_File);
    }
    if (this.FY2023_24_File) {

      formData.append('FY2023_24_File', this.FY2023_24_File);
    }
    if (this.FY2024_25_File) {

      formData.append('FY2024_25_File', this.FY2024_25_File);
    }

    // Append array data (participantList)
    //this.participantList.forEach((participant, index) => {
    //  Object.keys(participant).forEach(key => {
    //    formData.append(`onspotRegistrationParticipantDetails[${index}][${key}]`, participant[key]);
    //  });
    //});


    // --- Handling the 'newParticipants' FormArray data ---
    

    //onspotRegistrationParticipantDetails: this.participantList;


    // Return the FormData object
    //console.log("formdata", formData)
    return formData;

  }
  onSubmit() {
    this.isSubmitted = true;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.toastr.error("Please fill in all required fields correctly.");
      console.log('Form is invalid. Errors:', this.form.errors);
      return;
    }

    // IMPORTANT: Ensure  has actual data before proceeding
    
      //this.isSubmitted = true;
       const formDatas = this.prepareFormData();
       console.log(formDatas);
        this.saveEOIRegistration(formDatas);
      //this.toastr.error("OTP not verified or participant not added");
      return;
    
  }

  // Your existing saveOnSpotRegistration method - MODIFIED
  //ssaveEOIRegistration(formDatas: FormData) {
  //  this.apiService.postRequest(
  //    API_ENDPOINTS.EOI.EOI,
  //    formDatas
  //  ).subscribe(
  //    res => {
  //      if (res.status) {
  //        //this.toastr.success(res.message);
  //        this.toastr.success("Registration done");
  //        this.router.navigate(['/login']);
  //      }
       
  //    },
  //    err => {
  //      console.error('An error occurred during registration:', err);
  //      this.toastr.error('An error occurred, please try again.');
  //    }
       
  //  );
  //}

  //using this before pdf
  //saveEOIRegistration(formDatas: FormData): void {
  //  // 1. Set loadingSequence to true BEFORE making the API call
  //  this.loadingSequence = true;

  //  this.apiService.postRequest(
  //    API_ENDPOINTS.EOI.EOI,
  //    formDatas
  //  ).pipe(
  //    // 2. Use the finalize operator to set loadingSequence to false.
  //    //    This will run whether the observable completes successfully or with an error.
  //    finalize(() => {
  //      this.loadingSequence = false;
  //    })
  //  ).subscribe({
  //    // 3. Use the object-based subscribe for clearer handling of next and error
  //    next: (res: any) => {
  //      if (res.status) {
  //        this.toastr.success("Registration done");
  //        this.router.navigate(['/login']);
  //      } else {
  //        // Handle cases where the API call is successful but the server indicates a business error
  //        this.toastr.error(res.message || 'Registration failed, please try again.');
  //      }
  //    },
  //    error: (err: any) => {
  //      // This block handles actual HTTP errors (e.g., network issues, 4xx/5xx status codes)
  //      console.error('An error occurred during registration:', err);
  //      this.toastr.error('An error occurred, please try again.');
  //    }
  //  });
  //}

  

  onFY2020_21FileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.FY2020_21_Errors = { typeError: false, sizeError: false };
    this.form.get('FY2020_21_Name')?.setValue('');

    if (input.files && input.files.length) {
      this.FY2020_21_File = input.files[0];

      // Validate file type (Only PDF)
      if (this.FY2020_21_File.type !== 'application/pdf') {
        this.FY2020_21_Errors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.FY2020_21_File.size > maxSizeInBytes) {
        this.FY2020_21_Errors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.FY2020_21_Errors.typeError || this.FY2020_21_Errors.sizeError) {
        this.form.get('FY2020_21_File')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          FY2020_21_Name: this.FY2020_21_File.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('FY2020_21_Name')?.setValue('');
      this.form.get('FY2020_21_File')?.setValue(null);
    }
  }

  

  onFY2021_22FileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.FY2021_22_Errors = { typeError: false, sizeError: false };
    this.form.get('FY2021_22_Name')?.setValue('');

    if (input.files && input.files.length) {
      this.FY2021_22_File = input.files[0];

      // Validate file type (Only PDF)
      if (this.FY2021_22_File.type !== 'application/pdf') {
        this.FY2021_22_Errors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.FY2021_22_File.size > maxSizeInBytes) {
        this.FY2021_22_Errors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.FY2021_22_Errors.typeError || this.FY2021_22_Errors.sizeError) {
        this.form.get('FY2021_22_File')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          FY2021_22_Name: this.FY2021_22_File.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('FY2021_22_Name')?.setValue('');
      this.form.get('FY2021_22_File')?.setValue(null);
    }
  }

  

  onFY2022_23FileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.FY2022_23_Errors = { typeError: false, sizeError: false };
    this.form.get('FY2022_23_Name')?.setValue('');

    if (input.files && input.files.length) {
      this.FY2022_23_File = input.files[0];

      // Validate file type (Only PDF)
      if (this.FY2022_23_File.type !== 'application/pdf') {
        this.FY2022_23_Errors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.FY2022_23_File.size > maxSizeInBytes) {
        this.FY2022_23_Errors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.FY2022_23_Errors.typeError || this.FY2022_23_Errors.sizeError) {
        this.form.get('FY2022_23_File')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          FY2022_23_Name: this.FY2022_23_File.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('FY2022_23_Name')?.setValue('');
      this.form.get('FY2022_23_File')?.setValue(null);
    }
  }

  

  onFY2023_24FileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.FY2023_24_Errors = { typeError: false, sizeError: false };
    this.form.get('FY2023_24_Name')?.setValue('');

    if (input.files && input.files.length) {
      this.FY2023_24_File = input.files[0];

      // Validate file type (Only PDF)
      if (this.FY2023_24_File.type !== 'application/pdf') {
        this.FY2023_24_Errors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.FY2023_24_File.size > maxSizeInBytes) {
        this.FY2023_24_Errors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.FY2023_24_Errors.typeError || this.FY2023_24_Errors.sizeError) {
        this.form.get('FY2023_24_File')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          FY2023_24_Name: this.FY2023_24_File.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('FY2023_24_Name')?.setValue('');
      this.form.get('FY2023_24_File')?.setValue(null);
    }
  }

 

  onFY2024_25FileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Reset all errors and form control value initially
    this.FY2024_25_Errors = { typeError: false, sizeError: false };
    this.form.get('FY2024_25_Name')?.setValue('');

    if (input.files && input.files.length) {
      this.FY2024_25_File = input.files[0];

      // Validate file type (Only PDF)
      if (this.FY2024_25_File.type !== 'application/pdf') {
        this.FY2024_25_Errors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.FY2024_25_File.size > maxSizeInBytes) {
        this.FY2024_25_Errors.sizeError = true;
      }

      // If there are validation errors, clear the input
      if (this.FY2024_25_Errors.typeError || this.FY2024_25_Errors.sizeError) {
        this.form.get('FY2024_25_File')?.setValue(null);
        input.value = ''; // Clear the input field itself
      } else {
        // Set file name in form if validation passes
        this.form.patchValue({
          FY2024_25_Name: this.FY2024_25_File.name
        });
      }
    } else {
      // If no file is selected (e.g., user cancels), clear the form control and name
      this.form.get('FY2024_25_Name')?.setValue('');
      this.form.get('FY2024_25_File')?.setValue(null);
    }
  }
  onCancel() {
    if (confirm("Are you sure you want to cancel the form?")) {

      // Clear history state formData
      history.replaceState({}, '', window.location.pathname);

      //this.form.reset();


      sessionStorage.clear();
      this.form.reset();//added to reset the form
      this.router.navigate(['/eoiinvitation']);


    }
  }

  //generatePdf(): void {
  //  // Get the HTML element containing the form content
  //  const data = document.getElementById('eoiFormToPdf');

  //  if (data) {
  //    // Use html2canvas to render the HTML element into a canvas
  //    html2canvas(data, { scale: 2 }).then(canvas => { // Scale for better resolution
  //      const imgWidth = 208; // A4 width in mm
  //      const pageHeight = 295; // A4 height in mm
  //      const imgHeight = canvas.height * imgWidth / canvas.width;
  //      let heightLeft = imgHeight;

  //      // Initialize jsPDF
  //      const pdf = new jspdf.jsPDF('p', 'mm', 'a4'); // 'p' for portrait, 'mm' for millimeters, 'a4' for A4 size
  //      let position = 0;

  //      // Add the first page image
  //      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, position, imgWidth, imgHeight);
  //      heightLeft -= pageHeight;

  //      // Add more pages if content overflows a single A4 page
  //      while (heightLeft >= 0) {
  //        position = heightLeft - imgHeight;
  //        pdf.addPage();
  //        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, position, imgWidth, imgHeight);
  //        heightLeft -= pageHeight;
  //      }

  //      // Generate a dynamic filename using the Enterprise Name from the form
  //      const enterpriseName = this.form.get('EnterpriseName')?.value || 'EOI_Registration';
  //      pdf.save(`${enterpriseName}_Form.pdf`);
  //      this.toastr.info('Form downloaded as PDF.');
  //    }).catch(error => {
  //      console.error('Error generating PDF:', error);
  //      this.toastr.error('Failed to generate PDF. Please try again.');
  //    });
  //  } else {
  //    this.toastr.error('Form content not found for PDF generation. Please ensure the div with id "eoiFormToPdf" exists.');
  //  }
  //}


  //Dont consider
  //generatePdf(formData: any): void {
  //  // Initialize jsPDF with landscape orientation as per your design
  //  const doc = new jsPDF({
  //    orientation: 'landscape',
  //    unit: 'mm',
  //    format: 'a4',
  //  });

  //  // **Page Border**
  //  const margin = 10;
  //  const pageWidth = doc.internal.pageSize.width;
  //  const pageHeight = doc.internal.pageSize.height;
  //  doc.setDrawColor(0); // Black color for the border
  //  doc.setLineWidth(1); // 1mm line width
  //  doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin); // Draw the rectangle border

  //  // **Logos**
  //  // IMPORTANT: Ensure these paths are correct relative to your project's assets folder
  //  // For example, if your images are in 'src/assets/Images/', these paths are correct.
  //  const logo1 = 'assets/Images/RAMP_LOGO.jpg';
  //  const logo2 = 'assets/Images/logo_icon.png';
  //  const imgWidth = 30, imgHeight = 30, imgX1 = 15, imgX2 = 250, imgY = 15;

  //  // Create Image objects for asynchronous loading
  //  const logoImg1 = new Image();
  //  const logoImg2 = new Image();
  //  logoImg1.src = logo1;
  //  logoImg2.src = logo2;

  //  // Use Promise.all to wait for both images to load before adding them to the PDF
  //  Promise.all([
  //    new Promise<void>((resolve) => (logoImg1.onload = () => resolve())),
  //    new Promise<void>((resolve) => (logoImg2.onload = () => resolve())),
  //  ]).then(() => {
  //    // Add loaded images to the PDF
  //    doc.addImage(logoImg1, 'PNG', imgX1, imgY, imgWidth, imgHeight);
  //    doc.addImage(logoImg2, 'PNG', imgX2, imgY, imgWidth, imgHeight);

  //    // **Main Title**
  //    doc.setFont('helvetica', 'bold');
  //    doc.setFontSize(19);
  //    doc.setTextColor(197, 41, 42); // Reddish color
  //    // Center text using pageWidth / 2
  //    doc.text('Maharashtra Small Scale Industries Development Corporation Ltd.', pageWidth / 2, imgY + 5, { align: 'center' });

  //    doc.setFontSize(11);
  //    doc.setTextColor(0, 0, 0); // Black color
  //    doc.text('A Government Of Maharashtra Undertaking', pageWidth / 2, imgY + 12, { align: 'center' });

  //    doc.setFontSize(10);
  //    doc.text('CIN No. U74999MH1962SGC012501', pageWidth / 2, imgY + 18, { align: 'center' });

  //    // **Header Line**
  //    const lineY = imgY + imgHeight + 5; // Position the line below the logos and titles
  //    doc.setDrawColor(0); // Black color for the line
  //    doc.line(margin + 5, lineY, pageWidth - margin - 5, lineY); // Draw a line across the page

  //    // **Acknowledgment/Registration Title**
  //    doc.setFont('helvetica', 'bold');
  //    doc.setFontSize(19);
  //    doc.setTextColor(0, 86, 179); // Blue color
  //    // Center text below the line
  //    doc.text('EOI Registration Details', pageWidth / 2, lineY + 10, { align: 'center' });

  //    // --- Start adding form data below the header ---
  //    let yPos = lineY + 25; // Adjusted starting Y position for form data, leaving space for the header
  //    const xPosContent = 15; // Starting X position for form data text
  //    const lineHeight = 8; // Smaller line height for form data for more items per page

  //    doc.setFontSize(10); // Smaller font for details
  //    doc.setTextColor(0, 0, 0); // Ensure text color is black for form data
  //    doc.setFont('helvetica', 'normal'); // Reset font style to normal for data

  //    // Iterate over the formData object to add each field
  //    for (const key in formData) {
  //      if (formData.hasOwnProperty(key)) {
  //        // Skip keys that represent the actual file object or its temporary path.
  //        // Keys ending with 'Name' (like RentAgreementName) will be included.
  //        if (key.endsWith('File') || key.endsWith('Path')) {
  //          continue; // Skip this iteration, do not add this field to the PDF
  //        }

  //        let value = formData[key];

  //        // Special handling for boolean values (e.g., termsConditionAccepted)
  //        if (typeof value === 'boolean') {
  //          value = value ? 'Yes' : 'No';
  //        } else if (value === null || value === undefined || value === '') {
  //          value = 'N/A'; // Display 'N/A' for empty values
  //        }

  //        const fieldName = this.formatFieldName(key);
  //        const text = `${fieldName}: ${value}`; // Format key for readability

  //        // Check if content will overflow the current page
  //        // Add a new page if the next line exceeds the page height minus a bottom margin
  //        if (yPos + lineHeight > pageHeight - margin) {
  //          doc.addPage();
  //          // Redraw border and a simplified header on the new page for consistency
  //          doc.setDrawColor(0);
  //          doc.setLineWidth(1);
  //          doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);
  //          doc.setFont('helvetica', 'bold');
  //          doc.setFontSize(14); // Slightly smaller title for continued pages
  //          doc.setTextColor(0, 0, 0); // Black for continued title
  //          doc.text('EOI Registration Details (Continued)', pageWidth / 2, margin + 10, { align: 'center' });
  //          doc.setDrawColor(0);
  //          doc.line(margin + 5, margin + 20, pageWidth - margin - 5, margin + 20); // Line below continued title
  //          yPos = margin + 30; // Reset Y position for new page, leaving space for new header
  //          doc.setFontSize(10); // Reset font size for data
  //          doc.setTextColor(0, 0, 0); // Ensure text color is black
  //          doc.setFont('helvetica', 'normal'); // Reset font style
  //        }

  //        doc.text(text, xPosContent, yPos);
  //        yPos += lineHeight;
  //      }
  //    }

  //    // Generate a dynamic filename using the Enterprise Name from the form data
  //    const enterpriseName = formData.EnterpriseName || 'EOI_Registration';
  //    doc.save(`${enterpriseName}_Form_Data.pdf`);
  //    this.toastr.info('Form data downloaded as PDF.');
  //  }).catch(error => {
  //    // Handle errors during image loading or PDF generation
  //    console.error('Error generating PDF (images or content):', error);
  //    this.toastr.error('Failed to generate PDF. Please check image paths or try again.');
  //  });
  //}

  /**
   * Helper function to make field names more readable (e.g., 'UdyamRegistrationNumber' -> 'Udyam Registration Number')
   */
  private formatFieldName(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/_/g, ' ')         // Replace underscores with spaces
      .trim()                     // Trim leading/trailing spaces
      .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
  }

  saveEOIRegistration(formDatas: FormData): void {




    this.loadingSequence = true;





    this.apiService.postRequest(
      API_ENDPOINTS.EOI.EOI,
      formDatas
    ).pipe(
      finalize(() => {
        this.loadingSequence = false;
      })
    ).subscribe({
      next: (res: any) => {
        if (res.status && res.message == "EOI data processed successfully.") {
          this.toastr.success(res.message);
          
          //this.generatePdf(this.form.value);
          // 1. Generate the PDF and get the Blob
          const pdfBlob =this.generatePdf(this.form.value, res.data);

         
          

          // 2. Create FormData for the secondary API call
          const secondaryFormData = new FormData();

          secondaryFormData.append('ResponseDocFile', pdfBlob, `${res.data}_EOI_Form.pdf`);
          secondaryFormData.append('EnterpriseCode', res.data);
          
          // <<< NEW API CALL HERE (Success Block) >>>
          this.apiService.postRequest(
            API_ENDPOINTS.EOI.SAVEGENERATEDFORM, // Your target endpoint
            secondaryFormData // Pass the FormData containing the file
          ).subscribe({
            error: (err) => {
              console.error('Failed to upload generated form:', err);
            }
          });
          // <<< END NEW API CALL >>>

          const navigationState = {
            // Use the spread operator (...) to quickly include all form fields
            ...this.form.value,

            // Append the new data with a clear key
            enterpriseCode: res.data
          };
          this.router.navigate(
            ['/eoipdf'],
            { state: navigationState } /*this.form.value*/ 
          );
          //this.generatePdf(this.form.value); // <--- Pass the form's data here
          //this.router.navigate(['/login']);
        }
        else if (res.status && res.message != "EOI data processed successfully.") {
          //this.toastr.warning(res.message);
          

          let txtValue = "Applicant entity must be operational for a maximum of 5 years as on the date of application. You have exceeded this date.";
          const dialogRef = this.dialog.open(this.warningDialog,{
            width: '80%',
            height: '30',
            disableClose: true
          });

          //this.generatePdf(this.form.value);
          const pdfBlob = this.generatePdf(this.form.value, res.data);

          const secondaryFormData = new FormData();

          secondaryFormData.append('ResponseDocFile', pdfBlob, `${res.data}_EOI_Form.pdf`); 
          secondaryFormData.append('EnterpriseCode', res.data);
          // <<< NEW API CALL HERE (Success Block) >>>
          this.apiService.postRequest(
            API_ENDPOINTS.EOI.SAVEGENERATEDFORM, // Your target endpoint
            secondaryFormData // Pass the FormData containing the file
          ).subscribe({
            error: (err) => {
              console.error('Failed to upload generated form:', err);
            }
          });
          // <<< END NEW API CALL >>>

          const navigationState = {
            // Use the spread operator (...) to quickly include all form fields
            ...this.form.value,

            // Append the new data with a clear key
            enterpriseCode: res.data
          };
          this.router.navigate(
            ['/eoipdf'],
            { state: navigationState }
          );

        }
        else {
          this.toastr.error(res.message); /*|| 'Registration failed, please try again.');*/
        }
      },
      error: (err: any) => {
        console.error('An error occurred during registration:', err);
        this.toastr.error('An error occurred, please try again.');
      }
    });
  }


  async loadDistricts(): Promise<void> {
    const stateId = 27;
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.DISTRICT.GETDISTRICTBASEDONSTATE, { StateID: stateId }).subscribe(
      (result) => {
        if (result.status) {
          this.districtsBasedOnState = result.data;
          console.log('Districts loaded:', this.districtsBasedOnState);
        }
      },
      (error) => {
        console.error('Error fetching districts:', error);
      }
    );
  }

  //oonDistrictSelected(districtId: number): void {
  //  // Find the selected district object from the list based on the ID
  //  const selectedDistrict = this.districtsBasedOnState.find(
  //    (district) => district.districtId === districtId
  //  );

  //  // Check if a district was found
  //  if (selectedDistrict) {
  //    // Set the value for the District form control
  //    this.form.get('District')?.setValue(selectedDistrict.districtName);

  //    // The DistrictId is already set by the ng-select formControlName, but you can
  //    // also explicitly set it for clarity if needed:
  //    // this.yourFormName.get('DistrictId')?.setValue(selectedDistrict.districtId);

  //    console.log('Selected District ID:', selectedDistrict.districtId);
  //    console.log('Selected District Name:', selectedDistrict.districtName);
  //  } else {
  //    // Handle the case where the selection is cleared
  //    this.form.get('District')?.setValue(null);
  //    this.form.get('DistrictId')?.setValue(null); // Clear the ID as well
  //  }
  //}

  onDistrictSelected(selectedDistrict: any): void {
    if (selectedDistrict) {
      // Set the DistrictId form control
      this.form.get('DistrictId')?.setValue(selectedDistrict.districtId);

      // Set the District form control
      this.form.get('District')?.setValue(selectedDistrict.districtName);

      console.log('Selected District ID:', selectedDistrict.districtId);
      console.log('Selected District Name:', selectedDistrict.districtName);
    } else {
      // Handle the case where the selection is cleared
      this.form.get('District')?.setValue(null);
      this.form.get('DistrictId')?.setValue(null);
    }
  }
  // This is the function you'd call in your 'else if' block
  //showWarningModal(template: TemplateRef<any>) {
  //  this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  //}

  // A method to close the modal
  closeModal() {
    //this.modalRef.hide();
  }
  
  //added by ag on 15-10
  generatePdf(formData: any, enterpriseCode: string | null = null): Blob {
    
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    const margin = 10;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Border
    doc.setDrawColor(0);
    doc.setLineWidth(1);
    doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);

    // Logos
    const logo1 = 'assets/Images/RAMP_LOGO.jpg';
    const logo2 = 'assets/Images/logo_icon.png';
    doc.addImage(logo1, 'JPEG', 15, 15, 30, 30);
    doc.addImage(logo2, 'PNG', pageWidth - 45, 15, 30, 30);

    // Titles
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(197, 41, 42);
    doc.text(
      'Maharashtra Small Scale Industries Development Corporation Ltd.',
      pageWidth / 2,
      25,
      { align: 'center' }
    );

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text('A Government Of Maharashtra Undertaking', pageWidth / 2, 32, {
      align: 'center',
    });

    doc.setFontSize(10);
    doc.text('CIN No. U74999MH1962SGC012501', pageWidth / 2, 38, {
      align: 'center',
    });

    // Line
    const lineY = 55;
    doc.line(margin + 5, lineY, pageWidth - margin - 5, lineY);

    // Subtitle
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(0, 86, 179);
    doc.text('EOI Registration Details', pageWidth / 2, lineY + 10, {
      align: 'center',
    });

    // --- Helper function for key formatting ---
    function formatKey(key: string): string {
      return key
        // Insert space before capital letters
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        // Handle consecutive capitals (like ID, GST, PAN)
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        // Capitalize first letter of each word
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();
    }

    // --- Clean formData ---
    const cleaned: Record<string, any> = {};

    if (enterpriseCode) {
      // Assign to a new key, "EnterpriseCode", for display
      cleaned['EnterpriseCode'] = enterpriseCode;
    }

    for (const key in formData) {
      if (
        formData.hasOwnProperty(key) &&
        !key.endsWith('File') &&
        !key.endsWith('Path') &&
        key !== 'navigationId' &&
        key !== 'DistrictId'
      ) {
        let value = formData[key];
        if (typeof value === 'boolean') value = value ? 'Yes' : 'No';
        if (!value) value = 'N/A';
        cleaned[key] = value;
      }
    }

    // --- Convert to 2-column rows ---
    const rows: any[] = [];
    const entries = Object.entries(cleaned);

    for (let i = 0; i < entries.length; i += 2) {
      const col1Key = entries[i] ? formatKey(entries[i][0]) : '';
      const col1Val = entries[i] ? `${entries[i][1]}` : '';
      const col2Key = entries[i + 1] ? formatKey(entries[i + 1][0]) : '';
      const col2Val = entries[i + 1] ? `${entries[i + 1][1]}` : '';

      rows.push([
        { content: col1Key, styles: { fontStyle: 'bold' } },
        { content: col1Val, styles: { fontStyle: 'normal' } },
        { content: col2Key, styles: { fontStyle: 'bold' } },
        { content: col2Val, styles: { fontStyle: 'normal' } },
      ]);
    }

    // --- Table ---
    autoTable(doc, {
      startY: lineY + 20,
      head: [['', '', '', '']],
      body: rows,
      styles: { fontSize: 10, cellPadding: 3 },
      theme: 'grid',
      headStyles: { fillColor: [197, 41, 42], textColor: 255 },
      margin: { left: margin, right: margin },
    });

    // Save PDF
    const enterpriseName = cleaned['EnterpriseName'] || 'EOI_Registration';
    doc.save(`${enterpriseName}_Form_Data.pdf`);

    // 2. CRITICAL CHANGE: Return the PDF content as a Blob
    const pdfBlob = doc.output('blob');

    return pdfBlob;
  }
}

